{

    // 상품 상세정보 고정
    const initMainProductDetails = () => {
        const stickyEl = document.querySelector('.product__info-wrapper');
        const stopEl = document.querySelector('footer');
        if (!stickyEl || !stopEl) return;

        const headerHeight = 156;
        const stickyStart = stickyEl.offsetTop;

        function getStopPoint() {
            // footer의 실제 위치를 매번 새로 계산
            return stopEl.getBoundingClientRect().top + window.scrollY;
        }

        function updateSticky() {
            const scrollTop = window.scrollY;
            const stickyHeight = stickyEl.offsetHeight;
            const parentWidth = stickyEl.parentElement.offsetWidth;
            const stopPoint = getStopPoint();
            const padding = window.innerWidth > 1180 ? 80 : 15;

            if (window.innerWidth <= 1025) {
                stickyEl.style.position = 'relative';
                stickyEl.style.top = 'unset';
                stickyEl.style.width = '100%';
                stickyEl.style.left = 'unset';
                return;
            }

            // sticky가 footer에 도달했는지 확인
            if (scrollTop + headerHeight + stickyHeight >= stopPoint) {
                // footer 도달 - absolute로 고정
                stickyEl.style.position = 'absolute';
                stickyEl.style.top = stopPoint - stickyHeight + 'px';
                stickyEl.style.width = parentWidth * 0.4 + 'px';
                stickyEl.style.left = parentWidth - parentWidth * 0.4 + padding + 'px';
            } else if (scrollTop >= stickyStart - headerHeight) {
                // 스크롤 중 - fixed로 따라다님
                stickyEl.style.position = 'fixed';
                stickyEl.style.top = headerHeight + 'px';
                stickyEl.style.width = parentWidth * 0.4 + 'px';
                 stickyEl.style.left = parentWidth - parentWidth * 0.4 + padding - 12 + 'px';
            } else {
                // 초기 위치 - relative
                stickyEl.style.position = 'relative';
                stickyEl.style.top = 'unset';
                stickyEl.style.width = parentWidth * 0.4 + 'px';
                stickyEl.style.left = 'unset';
            }
        }

        //스크롤 및 리사이즈 이벤트
        window.addEventListener('scroll', updateSticky);

        // 초기 실행
        updateSticky();

        //상세 이미지 접고 펴기
        const parentSection = document.querySelector('.product-description.page-width')?.closest('.shopify-section');

        const relatedProduct = document.querySelector('.related-products')?.closest('.shopify-section');
        const reviewSection = document.querySelector('.pdp-reviews-container')?.closest('.shopify-section');

        let sizeSection = null;
        if (relatedProduct) {
            const allSections = Array.from(document.querySelectorAll('.shopify-section'));
            const sizeCandidates = allSections.filter(section => {
                const hasCorrectId = section.id && section.id.includes('image_banner');
                const hasImage = section.querySelector('img') !== null;
                const isAboveRelated = section.offsetTop < relatedProduct.offsetTop;
                
                return hasCorrectId && hasImage && isAboveRelated;
            });

            if (sizeCandidates.length > 0) {
                sizeSection = sizeCandidates[sizeCandidates.length - 1];
            } else {
                const tabItems = document.querySelectorAll('.product-tabs__nav li');
                tabItems.forEach((li) => {
                    if (li.innerText.replace(/\s/g, '').includes('사이즈')) {
                        li.style.display = 'none';
                    }
                });
            }
        }

        if (!parentSection) return;

        // wrapper 생성
        const wrapperContainer = document.createElement('div');
        wrapperContainer.className = 'detail-images-wrapper';

        // 상세 이미지 섹션 수집
        let el = parentSection.nextElementSibling;
        const sectionsToMove = [];

        while (el) {
            if (el === sizeSection || el === reviewSection || el === relatedProduct) {
                break;
            }
            
            if (el.querySelector('.pdp-reviews-container') || el.querySelector('.related-products')) {
                break;
            }

            const nextEl = el.nextElementSibling;
            sectionsToMove.push(el);
            el = nextEl;
        }

        sectionsToMove.forEach((section) => wrapperContainer.appendChild(section));

        if (sizeSection) {
            sizeSection.parentNode.insertBefore(wrapperContainer, sizeSection);
        } else {
            parentSection.after(wrapperContainer);
        }

        const wrapper = wrapperContainer;
        const images = wrapper.querySelectorAll('img');
        const hasImages = images.length > 0;

        if (!hasImages) {
            const tabItems = document.querySelectorAll('.product-tabs__nav li');
            tabItems.forEach((li) => {
                if (li.innerText.replace(/\s/g, '').includes('사이즈')) {
                    li.style.display = 'none';
                }
            });

            const customSizeHeading = document.querySelector('.custom-size-heading');
            if (customSizeHeading) customSizeHeading.style.display = 'none';

            wrapper.style.display = 'none';

            return;
        }

        function isMobile() {
            return window.matchMedia('(max-width: 1024px)').matches;
        }

        function getInitialHeight() {
            return isMobile() ? '300px' : '500px';
        }

        let isCollapsed = true;

        // wrapper 스타일
        wrapper.style.position = 'relative';
        wrapper.style.overflow = 'hidden';
        wrapper.style.maxHeight = getInitialHeight();
        wrapper.style.transition = 'max-height 0.4s ease';

        // 리사이즈 이벤트

        // 버튼 생성
        const buttonContainer = document.createElement('div');
        buttonContainer.className = 'toggle-images-btn';
        buttonContainer.innerHTML = isMobile()
            ? `
      <button type="button">
        <span>제품 상세 더보기</span>
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M18.8423 9.15566C19.0526 9.3632 19.0526 9.69969 18.8423 9.90724L13.1422 15.533C12.5114 16.1557 11.4886 16.1557 10.8577 15.533L5.1577 9.90724C4.9474 9.69969 4.9474 9.3632 5.1577 9.15566C5.368 8.94811 5.7089 8.94811 5.9192 9.15566L11.6192 14.7814C11.8295 14.989 12.1705 14.989 12.3807 14.7814L18.0808 9.15566C18.2911 8.94811 18.632 8.94811 18.8423 9.15566Z" fill="#171719"/>
        </svg>
      </button>
    `
            : `
      <button type="button">
        <span>제품 상세 더보기</span>
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M18.8423 9.15566C19.0526 9.3632 19.0526 9.69969 18.8423 9.90724L13.1422 15.533C12.5114 16.1557 11.4886 16.1557 10.8577 15.533L5.1577 9.90724C4.9474 9.69969 4.9474 9.3632 5.1577 9.15566C5.368 8.94811 5.7089 8.94811 5.9192 9.15566L11.6192 14.7814C11.8295 14.989 12.1705 14.989 12.3807 14.7814L18.0808 9.15566C18.2911 8.94811 18.632 8.94811 18.8423 9.15566Z" fill="#171719"/>
        </svg>
      </button>
    `;
        wrapper.appendChild(buttonContainer);

        const mask = document.createElement('div');
        mask.className = 'mobile-mask';
        mask.style.cssText = `
        height: 20px;
        background-color: #fff;
        bottom: 65px;
        position: relative;
        display: none; /* 초기값은 숨김 (모바일 체크 후 표시) */
    `;

        wrapper.after(mask);

        function updateMask() {
            if (isMobile() && isCollapsed) {
                mask.style.display = 'block';
            } else {
                mask.style.display = 'none';
            }
        }

        updateMask();

        const handleResize = () => {
            updateSticky();
            if (isCollapsed) {
                wrapper.style.maxHeight = getInitialHeight();
            }
            updateMask();
        };
        window.addEventListener('resize', handleResize);



        // 이벤트: buttonContainer에 이벤트 리스너 등록
        buttonContainer.addEventListener('click', (e) => {
            if (!e.target.closest('button')) return;

            isCollapsed = !isCollapsed;
            if (isCollapsed) {
                // 접기 클릭 시 product-description으로 스크롤
                const productDesc = document.querySelector('.product-description.page-width');
                if (productDesc) {
                    const productTabsHeight = 80;
                    const targetPosition =
                        productDesc.getBoundingClientRect().top + window.scrollY - headerHeight - productTabsHeight;
                    window.scrollTo({
                        top: targetPosition,
                        behavior: 'smooth',
                    });
                }

                setTimeout(() => {
                    wrapper.classList.remove('expanded');
                    wrapper.style.maxHeight = getInitialHeight();
                    buttonContainer.classList.remove('expanded');
                    buttonContainer.innerHTML = isMobile()
                        ? `
            <button type="button">
              <span>제품 상세 더보기</span>
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path fill-rule="evenodd" clip-rule="evenodd" d="M18.8423 9.15566C19.0526 9.3632 19.0526 9.69969 18.8423 9.90724L13.1422 15.533C12.5114 16.1557 11.4886 16.1557 10.8577 15.533L5.1577 9.90724C4.9474 9.69969 4.9474 9.3632 5.1577 9.15566C5.368 8.94811 5.7089 8.94811 5.9192 9.15566L11.6192 14.7814C11.8295 14.989 12.1705 14.989 12.3807 14.7814L18.0808 9.15566C18.2911 8.94811 18.632 8.94811 18.8423 9.15566Z" fill="#171719"/>
              </svg>
            </button>
          `
                        : `
            <button type="button">
              <span>제품 상세 더보기</span>
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path fill-rule="evenodd" clip-rule="evenodd" d="M18.8423 9.15566C19.0526 9.3632 19.0526 9.69969 18.8423 9.90724L13.1422 15.533C12.5114 16.1557 11.4886 16.1557 10.8577 15.533L5.1577 9.90724C4.9474 9.69969 4.9474 9.3632 5.1577 9.15566C5.368 8.94811 5.7089 8.94811 5.9192 9.15566L11.6192 14.7814C11.8295 14.989 12.1705 14.989 12.3807 14.7814L18.0808 9.15566C18.2911 8.94811 18.632 8.94811 18.8423 9.15566Z" fill="#171719"/>
              </svg>
            </button>
          `;
                }, 500);
            } else {
                //더보기 클릭 시
                wrapper.classList.add('expanded');
                wrapper.style.maxHeight = wrapper.scrollHeight + 'px';
                buttonContainer.classList.add('expanded');
                buttonContainer.innerHTML = isMobile()
                    ? `
          <button type="button">
            <span>제품 상세 접기</span>
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M5.15771 14.8443C4.94743 14.6368 4.94743 14.3003 5.15771 14.0928L10.8578 8.467C11.4886 7.8443 12.5114 7.8443 13.1423 8.467L18.8423 14.0928C19.0526 14.3003 19.0526 14.6368 18.8423 14.8443C18.632 15.0519 18.2911 15.0519 18.0808 14.8443L12.3808 9.2186C12.1705 9.011 11.8295 9.011 11.6193 9.2186L5.91921 14.8443C5.70893 15.0519 5.36799 15.0519 5.15771 14.8443Z" fill="#171719"/>
            </svg>
          </button>
        `
                    : `
          <button type="button">
            <span>제품 상세 접기</span>
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M5.15771 14.8443C4.94743 14.6368 4.94743 14.3003 5.15771 14.0928L10.8578 8.467C11.4886 7.8443 12.5114 7.8443 13.1423 8.467L18.8423 14.0928C19.0526 14.3003 19.0526 14.6368 18.8423 14.8443C18.632 15.0519 18.2911 15.0519 18.0808 14.8443L12.3808 9.2186C12.1705 9.011 11.8295 9.011 11.6193 9.2186L5.91921 14.8443C5.70893 15.0519 5.36799 15.0519 5.15771 14.8443Z" fill="#171719"/>
            </svg>
          </button>
        `;
            }

            // 버튼 클릭 후 sticky 위치 재계산 (데스크탑에서만)
            if (window.innerWidth > 1024) {
                setTimeout(() => {
                    updateSticky();
                }, 450);
            }
            updateMask();
        });
    };

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initMainProductDetails, { once: true });
    } else {
        initMainProductDetails();
    }

}